import { LinkDefault } from 'components/link-default'
import cx from 'classnames'
import React from 'react'

export type Props = {
  projectUrl: string
  logotypeUrl: string
  logotypeAlt: string
  size?: 'small' | 'large'
}

const HeaderLogoView = ({ projectUrl, logotypeUrl, logotypeAlt, size = 'small' }: Props) => (
  <LinkDefault
    external
    href={projectUrl} //TODO Add external link to product here
    target="_blank"
    rel="noopener noreferrer"
    className="flex justify-center">
    <img
      src={logotypeUrl}
      alt={logotypeAlt}
      className={cx(
        'max-w-[700px] w-auto h-auto object-scale-down',
        size === 'large' ? 'max-h-[100px]' : 'max-h-[48px]'
      )}
    />
  </LinkDefault>
)

export default HeaderLogoView
